// Consulta pública de CNPJ na BrasilAPI (open CORS, sem chave).
// Docs: https://brasilapi.com.br/docs#tag/CNPJ

const onlyDigits = (v) => String(v || "").replace(/\D/g, "");

export async function fetchCNPJ(cnpj) {
  const d = onlyDigits(cnpj);
  if (d.length !== 14) throw new Error("CNPJ deve ter 14 dígitos");
  const url = `https://brasilapi.com.br/api/cnpj/v1/${d}`;
  const resp = await fetch(url, { headers: { Accept: "application/json" } });
  if (resp.status === 404) throw new Error("CNPJ não encontrado na Receita");
  if (!resp.ok) throw new Error(`Falha na consulta (${resp.status})`);
  const data = await resp.json();
  // Monta endereço legível
  const partes = [
    [data.logradouro, data.numero].filter(Boolean).join(", "),
    data.complemento,
    data.bairro,
    [data.municipio, data.uf].filter(Boolean).join(" - "),
    data.cep ? `CEP ${data.cep}` : null,
  ].filter((p) => p && String(p).trim().length > 0);
  return {
    razao_social: data.razao_social || "",
    nome_fantasia: data.nome_fantasia || "",
    endereco_completo: partes.join(" · "),
    telefone: data.ddd_telefone_1 || "",
    email: data.email || "",
    situacao: data.descricao_situacao_cadastral || "",
    raw: data,
  };
}

// Consulta pública de CEP na BrasilAPI (open CORS, sem chave).
// Docs: https://brasilapi.com.br/docs#tag/CEP-V2
export async function fetchCEP(cep) {
  const d = onlyDigits(cep);
  if (d.length !== 8) throw new Error("CEP deve ter 8 dígitos");
  const url = `https://brasilapi.com.br/api/cep/v2/${d}`;
  const resp = await fetch(url, { headers: { Accept: "application/json" } });
  if (resp.status === 404) throw new Error("CEP não encontrado");
  if (!resp.ok) throw new Error(`Falha na consulta (${resp.status})`);
  const data = await resp.json();
  return {
    cep: data.cep || d,
    logradouro: data.street || "",
    bairro: data.neighborhood || "",
    cidade: data.city || "",
    uf: data.state || "",
    resumo: [
      data.street,
      data.neighborhood,
      [data.city, data.state].filter(Boolean).join(" - "),
    ].filter(Boolean).join(" · "),
    raw: data,
  };
}
